import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { FilteredSamplesComponent } from './filtered-samples/filtered-samples.component';
import { UnfilteredSamplesComponent } from './unfiltered-samples/unfiltered-samples.component';
import { ResponsiveService } from '../../../services/responsive.service';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { ApiQuery } from '../../../web-services/api/api.query';

@Component({
  selector: 'app-bin-capacity',
  standalone: true,
  imports: [CommonModule,TranslateModule,RTLDivDirectiveDirective,FilteredSamplesComponent,UnfilteredSamplesComponent,
    FormsModule,MatDividerModule],
  templateUrl: './bin-capacity.component.html',
  styleUrl: './bin-capacity.component.scss'
})
export class BinCapacityComponent {
  isMobile: Boolean;
	@Input() binLiveInfo_Bin; 		
	@Output() rangeBtnEvent = new EventEmitter<boolean>();
  isUnfilteredTransmission:boolean = false;
	user_role_id = 0;

	constructor(private responsiveService: ResponsiveService,private apiQuery:ApiQuery) {}

	ngOnInit() {
    this.onResize();
    this.responsiveService.checkWidth();
    this.apiQuery.user$.subscribe(user => {
			if (!user) return;
      this.user_role_id = user["user_role_id"];
		});
	}

  onResize() {
    this.responsiveService.getMobileStatus().subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  rangeBtnEventHander($event: any) {
    this.rangeBtnEvent.emit($event);
	}

  unfilteredTransmissionBtn(value){
    this.isUnfilteredTransmission = value;
  }
}
